import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
  authenticatedDelete,
  authenticatedFetch,
} from "../../api/authenticatedFetch";

const BASE = "/api/v1";
const API_URL = process.env.REACT_APP_API_URL;

export const listDataImportSchedules = async (params = {}) => {
  return authenticatedGet(`${BASE}/schedules`, params);
};

export const getSchedule = async (id) => {
  return authenticatedGet(`${BASE}/schedules/${id}`);
};

export const updateSchedule = async (id, body) => {
  return authenticatedPut(`${BASE}/schedules/${id}`, body);
};

export const deleteSchedule = async (id) => {
  return authenticatedDelete(`${BASE}/schedules/${id}`);
};

export const pauseSchedule = async (id) => {
  return authenticatedPost(`${BASE}/schedules/${id}/pause`, {});
};

export const resumeSchedule = async (id) => {
  return authenticatedPost(`${BASE}/schedules/${id}/resume`, {});
};

export const triggerSchedule = async (id) => {
  return authenticatedPost(`${BASE}/schedules/${id}/trigger`, {});
};

export const getScheduleHistory = async (id, limit = 20) => {
  return authenticatedGet(`${BASE}/schedules/${id}/history`, { limit });
};

export const getLogging = async (body, limit = 300, offset = 0) => {
  const response = await authenticatedFetch(
    `${API_URL}/get-logging?limit=${encodeURIComponent(limit)}&offset=${encodeURIComponent(offset)}`,
    { method: "POST", body }
  );
  return response.json();
};

export const getLoggingDetail = async (id) => {
  const response = await authenticatedFetch(
    `${API_URL}/get-logging/${encodeURIComponent(id)}`,
    { method: "GET" }
  );
  return response.json();
};

export const listPipelines = async () => {
  return authenticatedGet(`${BASE}/pipelines`);
};

export const getPipeline = async (id) => {
  return authenticatedGet(`${BASE}/pipelines/${id}`);
};

export const triggerPipeline = async (id) => {
  return authenticatedPost(`${BASE}/pipelines/${id}/trigger`, {});
};

// Stops the pipeline's current run — the live one, or a stale "running" row
// left behind by a process that died mid-run.
export const cancelPipeline = async (id) => {
  return authenticatedPost(`${BASE}/pipelines/${id}/cancel`, {});
};

export const pausePipeline = async (id) => {
  return authenticatedPost(`${BASE}/pipelines/${id}/pause`, {});
};

export const resumePipeline = async (id) => {
  return authenticatedPost(`${BASE}/pipelines/${id}/resume`, {});
};

export const getPipelineRuns = async (id, limit = 20) => {
  return authenticatedGet(`${BASE}/pipelines/${id}/runs`, { limit });
};

export const listSchedulesByType = async (jobType) => {
  return authenticatedGet(`${BASE}/schedules`, { job_type: jobType });
};

export const getLastRunFailures = async () => {
  return authenticatedGet(`${BASE}/pipelines/last-run-failures`);
};

// Latest forecast run per kind, with the series failures inside it. Distinct from
// getLastRunFailures: that counts failed JOBS, this reports what failed INSIDE a
// forecast run — including a run that succeeded while some series did not.
export const getForecastHealth = async () => {
  return authenticatedGet(`${BASE}/pipelines/forecast-health`);
};
